<template>
    <div>
        <h2>关于后勤价值型管理的补充建议</h2>
        <br>
         <VueEditor style="margin-top:20px" id="editor"  v-model="form.additionalDescription" useCustomImageHandler  @image-added="handleImageAdded"></VueEditor>
    </div>
</template>

<script>
import { putFile } from "@/api/crmedical/contract/add";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import { saveSugget,submitValueInfo } from '@/api/crmedical/value/valuebudget';
export default {
  props:{
    editDetailInfo:{}
  },
    components:{
        VueEditor
    },
    data(){
        return {
            form:{
              additionalDescription:''
            },
            validateFlag: false, //表单验证状态
        }
    },
    created(){
      this.initdata()
    },
    methods:{
      initdata(){
      this.form.additionalDescription = this.editDetailInfo['additionalDescription']
      console.log('最后一步',this.form)
    },
   async submit(){
      if(this.form.additionalDescription !=''&&this.form.additionalDescription !=undefined){
        await  saveSugget({
            additionalDescription:this.form.additionalDescription,
            id :this.editDetailInfo.id
          }).then(({ code }) => {
          if (code == 200) {
            this.$message({
              showClose: true,
              message: '数据保存成功',
              type: 'success',
            });
            this.validateFlag = true;
          } else {
            this.validateFlag = false;
          }
        });
      }else{
        this.$message({
          showClose: true,
          message: '建议不能为空！',
          type: 'error',
        });
        this.validateFlag = false;
      }
      return this.validateFlag 
    },
    async submit1(){
      if(this.form.additionalDescription !=''&&this.form.additionalDescription !=undefined){
        await this.submit()
        await  submitValueInfo({
            // additionalDescription:this.form.additionalDescription,
            id :this.editDetailInfo.id
          }).then(({ code }) => {
          if (code == 200) {
            this.$message({
              showClose: true,
              message: '方案已提交成功',
              type: 'success',
            });
            this.validateFlag = true;
          } else {
            this.validateFlag = false;
          }
        });
      }else{
        this.$message({
          showClose: true,
          message: '建议不能为空！',
          type: 'error',
        });
        this.validateFlag = false;
      }
      return this.validateFlag 
    },
          // 富文本处理图片上传问题
       handleImageAdded:function(file, Editor, cursorLocation, resetUploader) {
         if(this.VueEditorDisabled){
           return;
         }
          var formData = new FormData();
          formData.append("file", file);
          // 通过上传接口返回url，将url放入富文本编辑器中
          putFile(formData).then(res=>{
            let url = res.data.link;
            Editor.insertEmbed(cursorLocation, "image", url);
            resetUploader();
          }).catch(err => {
            console.log(err);
          });
       },
     
    },
    
}
</script>

<style>
</style>

